import React, { useContext } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import PropTypes from 'prop-types';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

const AppRoutes = ({ serverPages }) => {
  const { instance } = useContext(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route exact path={routes.thdCreditCard.path} element={<routes.thdCreditCard.component />} />
        <Route exact path={routes.home.path} element={<routes.home.component />} />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};

AppRoutes.propTypes = {
  serverPages: PropTypes.object,
};

export const App = ({
  customerType,
  serverPages
}) => {
  return (
    <>
      <AppRoutes
        customerType={customerType}
        serverPages={serverPages}
      />
    </>
  );
};

App.propTypes = {
  customerType: PropTypes.string.isRequired,
  serverPages: PropTypes.object,
};
